import Vue from 'vue';

// @ts-ignore
export const setAll = (state, all) => {
  state.all = all;
};

// @ts-ignore
export const setOne = (state, one) => {
  state.one = one;
};

// @ts-ignore
export const setStats = (state, one) => {
  state.stats = one;
};

// @ts-ignore
export const setGeneratedExternal = (state, {id, html}) => {
  Vue.set(state.generatedExternal, id, html);
};
